export default __webpack_public_path__ + "static/media/menu-join-white.3fb2d915.svg";